import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DirtyComponent } from '../../../../../helpers/CanDeactivate/dirty-component';
import { ConfigService } from '../../../../../helpers/config.service';
import { VendorsService } from '../../../services/vendors.service';
import { CustomValidator } from '../../../../../helpers/custom.validator';

@Component({
  selector: 'app-decline-vendor-withdrawal-request',
  templateUrl: './decline-vendor-withdrawal-request.component.html',
  styles: ``
})
export class DeclineVendorWithdrawalRequestComponent extends DirtyComponent implements OnInit {
  override formGroup!: FormGroup;
  loading: boolean = false;

  constructor(private _formBuilder: FormBuilder,
    translate: TranslateService,
    override dialogRef: MatDialogRef<DeclineVendorWithdrawalRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _config: ConfigService,
    private _vendorService:VendorsService) {
    super(translate)
  }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      request_id: new FormControl(this.data),
      reject_reason: new FormControl('', [Validators.required, CustomValidator.noWhiteSpace, Validators.maxLength(500)]),
    })
  }



  OnSubmit() {
    if (this.formGroup.invalid) {
      return
    }
    this.loading = true;
    const formData = new FormData()
    formData.append("reject_reason", this.formGroup.value.reject_reason)
    formData.append("request_id", this.formGroup.value.request_id)
    this._vendorService.DeclineVendorWithdrawalRequest(formData).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.dialogRef.close(true);
        this._config.SusseccMessage(this.translate.instant("withdrawalRequests.Request is rejected"))
      },
      error: (err: any) => {
        this.loading = false;

      }
    });
  }


}

